import React, { Component } from 'react'

class RestrictionScreen extends Component {
  constructor(props) {
    super(props);

    this.goHome = this.goHome.bind(this)
  }

  goHome() {
    this.props.history.push('/')
  }

  render() {
      return (
        <div className="animated fadeIn">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="h-80vh-c flex-row align-items-center">
                    <div className="row justify-content-center">
                      <div className="col-md-12">
                        <div className="clearfix text-center">
                          <h3 className="pt-3">Sorry, You don't have access to this page!</h3>
                          <p>- relax. this is not an <span className="text-danger">error</span>, just a page permissions <span className="text-warning">warning</span> -</p>
                          <button className="btn btn-blue-g btn-round" onClick={this.goHome}>Go Home</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
  }

}

export default RestrictionScreen;


// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/page/restriction.js